// 年齡彙總頁共用設定。
// /age-groups 與 /age/[ageGroup]/[category] 兩頁共用。

// 年齡層：name 取自 utils/staticContent.js 的 ageRange，slug 為 URL 用值，
// display 為文案／標題用顯示名稱（純數字範圍補「歲」），
// ageRange 為 staticContent.ageRange 的 id（1-6），供 go-api age_range 參數使用。
export const AGE_GROUPS = [
  { slug: 'under-18', name: '18歲以下', display: '18歲以下', ageRange: 1 },
  { slug: '18-24', name: '18-24', display: '18-24歲', ageRange: 2 },
  { slug: '25-34', name: '25-34', display: '25-34歲', ageRange: 3 },
  { slug: '35-44', name: '35-44', display: '35-44歲', ageRange: 4 },
  { slug: '45-54', name: '45-54', display: '45-54歲', ageRange: 5 },
  { slug: '55-up', name: '55或以上', display: '55歲或以上', ageRange: 6 },
];

// 主分類（first_category）與細分類（second_category）的 URL 區段直接用 DB 的數字 id，
// 例如 /age/25-34/1（主分類 id=1）/15（細分類 id=15）。
// 名稱一律從 appLaunch 的 category_tree 取得。

export const getAgeGroup = (slug) =>
  AGE_GROUPS.find((g) => g.slug === slug) || null;
